'use client';

import { createContext, useContext } from 'react';
export interface ClarityState {
  readonly enabled: boolean;
  readonly accountUuid: string | null;
}
export const defaultClarityState: ClarityState = {
  enabled: false,
  accountUuid: null
};
export const ClarityStateContext = createContext<ClarityState>(defaultClarityState);
export function useClarityState() {
  return useContext(ClarityStateContext);
}